import { render, staticRenderFns } from "./FormFieldHolderGroup.vue?vue&type=template&id=b065c384&scoped=true&"
import script from "./FormFieldHolderGroup.vue?vue&type=script&lang=js&"
export * from "./FormFieldHolderGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldHolderGroup.vue?vue&type=style&index=0&id=b065c384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b065c384",
  null
  
)

export default component.exports